<template>
  <section class="relative pb-0">
    <div class="">
      <div class="overflow-hidden">
        <transition name="fade" mode="out-in">
          <div class="container" :key="index">
            <h3 class="text-center mb-8">
              {{ title }}
            </h3>
            <p class="text-p1 text-center mb-8" v-html="subtitle" />
          </div>
        </transition>

        <div class="overflow-y-hidden">
          <div class="px-4 flex flex-row gap-8 snap-x overflow-x-auto px-24 mb-3 pb-8 -mb-8" ref="slider">
            <pict
              v-for="(image, i) in imageSrcs"
              :key="i"
              :data-index="i"
              ref="images"
              :default="image.default"
              :sources="image.sources"
              class="snap-center image"
            />
          </div>
        </div>

        <div v-if="!spaceB2b" class="min-h-20">
          <transition name="fade" mode="out-in">
            <div class="container" :key="index">
              <p v-if="caption" class="text-center text-legal pt-6 mb-0">
                {{ caption }}
              </p>
            </div>
          </transition>
        </div>
      </div>

      <div class="container p-4">
        <join-button class="mt-4" :login-path="loginPath" :signup-path="signupPath" />
      </div>
    </div>
  </section>
</template>

<script>
import Pict from "@/shared/pict"
import JoinButton from "../join-button"

import image1 from "../../images/slider-1.png"
import image12x from "../../images/slider-1@2x.png"

import image2 from "../../images/slider-2.png"
import image22x from "../../images/slider-2@2x.png"

export default {
  name: "SpacesExplainerMobile",
  components: {
    Pict,
    JoinButton
  },
  props: {
    copy: {
      type: Array,
      required: true
    },
    spaceB2b: {
      type: Boolean,
      required: true
    },
    signupPath: {
      type: String,
      required: true
    },
    loginPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      index: 0
    }
  },
  computed: {
    title() {
      return this.copy[this.index].title
    },
    subtitle() {
      const itemCopies = this.copy[this.index]

      if (this.spaceB2b) {
        return "subtitleB2b" in itemCopies ? itemCopies.subtitleB2b : itemCopies.subtitle
      } else {
        return itemCopies.subtitle
      }
    },
    caption() {
      const itemCopies = this.copy[this.index]

      if (this.spaceB2b) {
        return "captionB2b" in itemCopies ? itemCopies.captionB2b : itemCopies.caption
      } else {
        return itemCopies.caption
      }
    },
    imageSrcs() {
      return [
        {
          default: {
            src: image1,
            srcset: {
              "2x": image12x
            }
          },
          sources: [
            {
              media: "s",
              src: image1,
              srcset: {
                "2x": image12x
              }
            },
            {
              media: "m",
              src: image1,
              srcset: {
                "2x": image12x
              }
            }
          ]
        },

        {
          default: {
            src: image2,
            srcset: {
              "2x": image22x
            }
          },
          sources: [
            {
              media: "s",
              src: image2,
              srcset: {
                "2x": image22x
              }
            },
            {
              media: "m",
              src: image2,
              srcset: {
                "2x": image22x
              }
            }
          ]
        }
      ]
    }
  },

  mounted() {
    this.$refs.slider.scrollLeft = 0

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.index = parseInt(entry.target.dataset.index)
          }
        })
      },
      { threshold: 1.0 }
    )

    this.$refs.images.forEach((el) => observer.observe(el.$el))
  }
}
</script>

<style scoped>
.snap-x {
  scroll-snap-type: x mandatory;
}

.snap-center {
  scroll-snap-align: center;
}

.image {
  flex-shrink: 0;
  width: 233px;
  height: 483px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity, 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
